var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState, } from "react";
import useIntelligentTimer from "./useIntelligentTimer";
var Context = createContext(undefined);
export var SleepingProvider = function (_a) {
    var children = _a.children;
    var _b = useIntelligentTimer(), startTimer = _b[0], stopTimer = _b[1];
    var _c = useState(false), sleeping = _c[0], setSleeping = _c[1];
    // Allow subscriptions to wake/sleep events
    // This allows logic to know when the overlay was re-awoken, even if it was already awake
    var _d = useState({
        wake: [],
        sleep: [],
    }), callbacks = _d[0], setCallbacks = _d[1];
    var on = useCallback(function (event, fn) {
        setCallbacks(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[event] = __spreadArray(__spreadArray([], prev[event], true), [fn], false), _a)));
        });
    }, []);
    var off = useCallback(function (event, fn) {
        setCallbacks(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[event] = prev[event].filter(function (f) { return f !== fn; }), _a)));
        });
    }, []);
    // Wake the overlay for x milliseconds
    var wake = useCallback(function (time) {
        setSleeping(false);
        callbacks.wake.forEach(function (fn) { return fn(time); });
        startTimer(function () { return setSleeping(true); }, time);
    }, [callbacks.wake, startTimer]);
    // Immediately sleep the overlay
    var sleep = useCallback(function () {
        setSleeping(true);
        callbacks.sleep.forEach(function (fn) { return fn(); });
        stopTimer();
    }, [callbacks.sleep, stopTimer]);
    // Expose the full object for sleeping
    var obj = useMemo(function () { return ({
        sleeping: sleeping,
        wake: wake,
        sleep: sleep,
        on: on,
        off: off,
    }); }, [sleeping, wake, sleep, on, off]);
    return _jsx(Context, { value: obj, children: children });
};
var useSleeping = function () {
    var ctx = useContext(Context);
    if (!ctx)
        throw new Error("useSleeping must be used within a SleepingProvider");
    return ctx;
};
export default useSleeping;
